import React from 'react';
import { PaginateProvider } from 'contexts/paginate';
import IndexContainer from 'components/session_info/index_container';

const SessionInfo = () => {
  return (
    <PaginateProvider>
      <IndexContainer />
    </PaginateProvider>
  );
};

export default SessionInfo;
